export default __webpack_public_path__ + "static/media/vouchers_Mob_roi.7ea51487.png";